module.exports = __webpack_public_path__ + "static/media/81.1786774a.jpg";